import TwitterDashboardView from "src/sections/dashboards/platforms/twitter/twitter-dashboard-view";

const TwitterMainDashboardPage = () => <TwitterDashboardView type="main" />;

export default TwitterMainDashboardPage;
